import { categoryListStyles } from "@insite/content-library/Widgets/Category/CategoryList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// CategoryList
categoryListStyles.container = {
    gap: 0,
    css: css`
        width: 100%;
        margin-bottom: 30px;
        border: 1px solid ${getColor("common.border")};
        padding: 10px;
    `,
};

categoryListStyles.categoryItem = {
    // width is dynamic here
    width: 0,
    css: css`
        color: blue;
    `,
};

categoryListStyles.innerContainer = {
    gap: 0,
};

categoryListStyles.categoryNameLinkItem = {
    width: 12,
    css: css`
        padding-top: 10px
        padding-bottom: 10px;
    `,
};
